import {IAppV1Configurations} from '@app/v1_integration/interfaces';

/**
 *
 */
export const APP_NAME = 'pulseApp';
export const APP_CSS_ROOT_CLASS_SELECTOR = '.pulseapp'; // For bootstrapping
export const app = angular.module(APP_NAME);
export const v1_config: IAppV1Configurations = eval('Pulse.config');
